// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"70731d8b","480":"025a2ef0","838":"d2e9579e"}[chunkId] + ".js";
};